import { ContractRequest } from 'ng2-app/services/contract-requests/contract-request.model';
import { State, Action, StateContext, Selector, Store } from '@ngxs/store';
import { Injectable } from '@angular/core';
import { ContractRequestService } from 'ng2-app/services/contract-requests/contract-request.service';
import {
  CreateContractRequest,
  UpdateContractRequest
} from 'ng2-app/services/contract-requests/contract-request.actions';



export class ContractRequestStateModel {
  contractRequests: Array<ContractRequest>;
  loading: boolean;
}

@State<ContractRequestStateModel>({
  name: 'contractRequests',
  defaults: {
    contractRequests: [],
    loading: false,
  }
})

@Injectable()
export class ContractRequestState {

  @Selector()
  static contractRequests(state: ContractRequestStateModel) {
    return state.contractRequests;
  }

  constructor(
    private store: Store,
    private contractRequestService: ContractRequestService,
  ) {}

  @Action(UpdateContractRequest)
  updateContractRequest({ getState, patchState }: StateContext<ContractRequestStateModel>, {contractRequest}: UpdateContractRequest) {
    return this.contractRequestService.update(contractRequest);
  }

  @Action(CreateContractRequest)
  createContractRequest({ getState, patchState }: StateContext<ContractRequestStateModel>, {contractRequest}: CreateContractRequest) {
    return this.contractRequestService.create(contractRequest);
  }


}
